import { Collapse } from '@mui/material'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import Typography from '@mui/material/Typography'
import Box from '@mui/material/Box'
import { faWifi } from '@fortawesome/free-solid-svg-icons/faWifi'
import { faEnvelope } from '@fortawesome/free-solid-svg-icons/faEnvelope'
import { faChevronDown } from '@fortawesome/free-solid-svg-icons/faChevronDown'
import { faChevronUp } from '@fortawesome/free-solid-svg-icons/faChevronUp'
import React, { useState } from 'react'

export const MfaHelpInfo = () => {
	const [open, setOpen] = useState(false)

	return (
		<>
			<Box
				sx={{
					display: 'flex',
					alignItems: 'center',
					gap: 1,
					my: 1,
					cursor: 'pointer'
				}}
				onClick={() => setOpen(!open)}
			>
				<Typography component="span" sx={{ color: '#7088AA' }}>
					Having trouble getting code?
				</Typography>
				<FontAwesomeIcon icon={open ? faChevronUp : faChevronDown} />
			</Box>
			<Collapse in={open} timeout={800}>
				<Box
					sx={{
						display: 'flex',
						flexDirection: 'column',
						gap: 1,
						p: 2,
						border: '1px solid #7088aa21',
						borderRadius: '4px',
						backgroundColor: '#e5eeff'
					}}
				>
					<Box sx={{ mb: '12px' }}>
						<Typography
							component="span"
							sx={{ color: '#2c405a', fontWeight: 'bold' }}
						>
							Here a few things to try:
						</Typography>
					</Box>
					<Box>
						<FontAwesomeIcon icon={faWifi} color={'#2C405A8C'} />
						<Typography component="span" sx={{ mx: 1, color: '#2c405a' }}>
							Make sure you have network signal
						</Typography>
					</Box>
					<Box sx={{ pl: '2px' }}>
						<FontAwesomeIcon icon={faEnvelope} color={'#2C405A8C'} />
						<Typography component="span" sx={{ ml: 1, color: '#2c405a' }}>
							Check your spam or junk folder
						</Typography>
					</Box>
					<Box>
						<Typography component="span">
							Still can't get code?
							<Typography component="span" sx={{ mx: 1 }}>
								Contact manager
							</Typography>
						</Typography>
					</Box>
				</Box>
			</Collapse>
		</>
	)
}